import React, { Component, ComponentProps, FC, ReactNode } from 'react';

import cx from 'classnames';

import { AllOrNothing } from 'utils/types';

import Icon from '../Icon';
import Tooltip, { VARIANTS } from '../Tooltip';
import s from './index.module.css';

type TIconButton = {
  icon: Component | ReactNode | (() => JSX.Element);
  onClick?: (args: any) => void;
  className?: string;
  disabled?: boolean;
  iconProps?: ComponentProps<typeof Icon>;
} & AllOrNothing<{
  withTooltip: true;
  tooltipContent: ReactNode;
  tooltipId: string;
}> &
  ComponentProps<'button'>;

export const IconButton: FC<TIconButton> = ({
  icon,
  onClick,
  disabled,
  withTooltip = false,
  tooltipId,
  tooltipContent,
  className,
  iconProps,
  ...rest
}) => {
  const button = (
    <button onClick={onClick} className={cx(s.button, className)} disabled={disabled} {...rest}>
      <Icon component={icon} width="22px" height="22px" {...iconProps} />
    </button>
  );

  if (withTooltip) {
    return (
      <div data-tip data-for={tooltipId}>
        {button}
        <Tooltip variant={VARIANTS.DARK} id={tooltipId} className={s.tooltip} disable={disabled}>
          {tooltipContent}
        </Tooltip>
      </div>
    );
  }

  return button;
};
